import {
  Directive,
  Injector,
  Input,
  OnInit,
  Type,
  ViewContainerRef,
  ɵcreateInjector as createInjector,
  inject,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { UiLazyRenderedModule } from './bosch-ui-load-module-based-on-screen-width.model';
import { DESKTOP_MIN_WIDTH } from '../../basics/cconstants/bosch-ui-desktop-width.constant';

@Directive({
  selector: '[loadModuleBasedOnScreenWidth]',
})
export class BoschUiLoadModuleBasedOnScreenWidthDirective<ModuleType extends object> implements OnInit {
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly injector = inject(Injector);
  private readonly document: Document = inject(DOCUMENT);

  @Input() desktopModuleRef: (() => Promise<unknown>) | null = null;
  @Input() mobileModuleRef: (() => Promise<unknown>) | null = null;

  async ngOnInit(): Promise<void> {
    const module = await this.getModuleRef();
    this.render(module);
  }

  private render(module: UiLazyRenderedModule | null): void {
    if (module) {
      this.viewContainerRef.clear();
      const componentRef = this.viewContainerRef.createComponent(module.renderComponent);
      componentRef.changeDetectorRef.detectChanges();
    }
  }

  private async getModuleRef(): Promise<UiLazyRenderedModule | null> {
    const SCREEN_WIDTH = (this.document.defaultView && this.document.defaultView.innerWidth) || 0;
    const lazyModuleRef = SCREEN_WIDTH < DESKTOP_MIN_WIDTH ? this.mobileModuleRef : this.desktopModuleRef;

    if (lazyModuleRef) {
      const moduleRef = (await lazyModuleRef()) as ModuleType;
      const moduleRefKey = Object.keys(moduleRef)[0] as keyof ModuleType;

      const injector = createInjector(moduleRef[moduleRefKey], this.injector);
      return injector.get(moduleRef[moduleRefKey] as Type<UiLazyRenderedModule>);
    }

    return null;
  }
}
